import {Badge} from "@/lib/components/Badge";
import * as React from "react";
import {OrderStatus} from "@/model/order";
import { CommonI18N } from "@/translations";
import {useAppTheme} from "@/app/AppThemeContext";
import {useTranslation} from "react-i18next";
import {color_blue, color_green, color_grey, color_orange, color_purple} from "@/agentur/AgenturColors";

/**
 * Returns the background color for a given order status.
 */
export function getOrderStatusColor(mode: "dark" | "light", status?: OrderStatus): string {
    switch (status) {
        case OrderStatus.PENDING:
            return color_blue[mode === "dark" ? 2 : 3];
        case OrderStatus.ORDER_CONFIRMED:
            return color_orange[2];
        case OrderStatus.DELIVERY_DATE_PROPOSED:
            return color_orange[mode === "dark" ? 1 : 0];
        case OrderStatus.DELIVERY_DATE_CONFIRMED:
            return color_purple[mode === "dark" ? 2 : 4];
        case OrderStatus.DELIVERED:
            return color_green[2];
        case OrderStatus.CANCELLED_BY_SUPPLIER:
        case OrderStatus.CANCELLED_BY_REQUESTER:
            return color_grey[3];
        case OrderStatus.DEACTIVATED:
            return color_grey[2];
        default:
            return color_grey[3];
    }
}

/**
 * Returns the translated display text for a given order status.
 */
export function getOrderStatusText(t: (key: string) => string, status?: OrderStatus): string {
    if (!status) return "";
    const key = (CommonI18N.enum.orderStatus as Record<OrderStatus, string>)[status];
    return key ? t(key) : status;
}

/**
 * Displays a colored badge for an order status.
 */
export const OrderStatusBadge = ({ status, fullWidth }: { status?: OrderStatus; fullWidth?: boolean }) => {
    const theme = useAppTheme();
    const { t } = useTranslation();
    const label = getOrderStatusText(t, status);
    return status ? (
        <Badge label={label} backgroundColor={getOrderStatusColor(theme.mode, status)} fullWidth={fullWidth} />
    ) : null;
};
